import { capitalizeWords } from '@/composables/textUtils';

/**
 * Getters
 */
export default {
    isLoggedIn(state) {
        return state.loggedIn;
    },
    getUserSlug(state) {
        if (!state.loggedIn)
            return '';
        return state.user.uuid;
    },
    getUserLang(state) {
        return state.user_lang;
    },
    getUser(state) {
        return state.user;
    },
    isLoggedUserAdmin(state) {
        return [0, '0'].includes(state.user.status) ? true : false;
    },
    getUserName(state) {
        if (!state.loggedIn || [null, undefined].includes(state.user))
            return '';
        return capitalizeWords(state.user.name);
    },
    getProfileImage(state) {
        return state.user != null ? state.user.photo : '';
    },
    getSessionMessage(state) {
        return { message: state.sessionMessage, type: state.sessionMessageType };
    },
    hasSessionManage(state) {
        return state.sessionMessage != null ? true : false;
    },
    getWholeDataChest(state) {
        return state.dataChest;
    },
    getComboChest(state) {
        return state.comboChest;
    },
    getOnComboChest: (state) => (key) => {
        if (state.comboChest[key] === undefined || state.comboChest == null)
            return [];
        if (!state.comboChest[key])
            return [];
        return state.comboChest[key];
    },
    getDataChest(state) {
        return state.dataChest;
    },
    getOnDataChest: (state) => (key) => {
        if (state.dataChest[key] === undefined || state.dataChest == null)
            return [];
        if (!state.dataChest[key])
            return [];
        return state.dataChest[key];
    },
    getCookieAccepted(state) {
        return state.cookiesAccepted;
    },
    getToken(state) {
        return state.token;
    },
    getRegeneratorCalled(state) {
        return state.regeneratorCalled;
    },
    getRequestedRoute(state) {
        return state.requested_route;
    },
    getRequestedRouteQuery(state) {
        return state.requested_route_query;
    },
    getCalledRequests(state) {
        return state.calledRequests;
    },
    isLogging(state) {
        return state.isLogging;
    },
    getContext(state) {
        return state.context;
    },
    getPurchaseItems(state) {
        return state.purchaseItems;
    }
};